export enum BusinessTimeSlotType {
    UNKNOWN,
    TENMINUTE,
    FIFTEENMINUTE,
    TWENTYMINUTE,
    THIRTYMINUTE,
    FORTYFIVEMINUTE,
    HOURLY
}